module.exports = __webpack_public_path__ + "img/cloud-service.3be92b44.png";